/**
 * E2E stub for JaakVisageCapture (plan 08 F1). Ver hermano
 * `JaakDocumentCaptureStub.tsx` para el racional general.
 */
import type { JaakVisageResult } from '@tankef/core';

import type { JaakVisageCaptureProps } from '../JaakVisageCapture';

// Genera un JPEG sintético para la selfie. Dev local (VITE_KYC_LOCAL_STUB)
// pega al BE real y necesita un blob válido; tests E2E que mockean la API
// también lo aceptan sin problema.
function buildStubResult(): JaakVisageResult {
  if (typeof document === 'undefined') {
    return { base64: 'data:image/jpeg;base64,STUB' };
  }
  const canvas = document.createElement('canvas');
  canvas.width = 480;
  canvas.height = 640;
  const ctx = canvas.getContext('2d');
  if (!ctx) return { base64: 'data:image/jpeg;base64,STUB' };
  ctx.fillStyle = '#9b59b6';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#ffffff';
  ctx.font = '32px sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText('SELFIE (stub)', canvas.width / 2, canvas.height / 2);
  return { base64: canvas.toDataURL('image/jpeg', 0.9) };
}

export function JaakVisageCaptureStub(props: JaakVisageCaptureProps) {
  return (
    <div
      data-testid="jaak-visage-capture-stub"
      style={{
        padding: 20,
        border: '2px dashed #888',
        borderRadius: 8,
        textAlign: 'center',
      }}
    >
      <p style={{ margin: 0, marginBottom: 12 }}>
        [E2E STUB] JaakVisageCapture — controles manuales para tests
      </p>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
        <button
          type="button"
          data-testid="jaak-visage-capture-stub-complete"
          onClick={() => props.onCaptureComplete(buildStubResult())}
        >
          Complete selfie
        </button>
        <button
          type="button"
          data-testid="jaak-visage-capture-stub-error"
          onClick={() => props.onError?.('E2E_STUB_ERROR')}
        >
          Trigger error
        </button>
        <button
          type="button"
          data-testid="jaak-visage-capture-stub-cancel"
          onClick={() => props.onCancel?.()}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
